import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisibilityAreaService {
  private visibilityAreaClasses: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  public changeVisibilityArea(action: 'add' | 'delete', className: string) {
    let updatedClasses = this.visibilityAreaClasses.value || '';

    if (action === 'add' && !updatedClasses.includes(className)) {
      updatedClasses += ' ' + className;
    } else if (action === 'delete') {
      updatedClasses = updatedClasses.replace(className, '');
    }
    updatedClasses = updatedClasses.trim();

    this.visibilityAreaClasses.next(updatedClasses);
  }

  public getVisibilityAreaClasses(): Observable<string> {
    return this.visibilityAreaClasses.asObservable();
  }
}
